AFRAME.registerComponent('watchlist-main-empty-state', {
    init: function () {
        this.currentMode = null;
        
        this.el.sceneEl.addEventListener('watchlist-main-empty-state', (e) => {
            const detail = e.detail;
            if (detail && detail.active) {
                this.show(detail.action);
            } else {
                this.hide();
            }
        });
        
        this.el.sceneEl.addEventListener('theme-changed', () => {
             if (this.el.getAttribute('visible')) {
                 this.render();
             }
        });
    },

    show: function (mode) {
        this.currentMode = mode || 'create';
        this.el.setAttribute('visible', true);
        const centerPanel = document.getElementById('large-center-panel');
        if (centerPanel) {
            centerPanel.setAttribute('visible', false);
        }
        const switchTableChart = document.getElementById('switch-table-chart');
        if (switchTableChart) {
            switchTableChart.setAttribute('visible', false);
        }
        this.render();
    },

    hide: function () {
        this.el.setAttribute('visible', false);
        this.el.innerHTML = ''; 
        
        const switchTableChart = document.getElementById('switch-table-chart');
        if (switchTableChart) {
            switchTableChart.setAttribute('visible', true);
            
            const switchCtrl = switchTableChart.components['switch-table-chart'];
            if (switchCtrl) {
                const centerPanel = document.getElementById('large-center-panel');
                if (centerPanel) {
                    centerPanel.setAttribute('visible', switchCtrl.currentView === 'chart');
                }
            } else {
                const centerPanel = document.getElementById('large-center-panel');
                if (centerPanel) {
                    centerPanel.setAttribute('visible', true);
                }
            }
        } else {
            const centerPanel = document.getElementById('large-center-panel');
            if (centerPanel) {
                centerPanel.setAttribute('visible', true);
            }
        }
    },

    _isLightMode: function() {
        if (typeof getCacheItem === 'function') {
            const settings = getCacheItem('mainSettings');
            if (settings && settings.themeMode) {
                return settings.themeMode === 'Light';
            }
        }
        return false;
    },

    render: function () {
        this.el.innerHTML = '';
        
        const isLight = this._isLightMode();
        const panelColor = isLight ? '#F5F5F5' : '#111';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 0.6);
        bg.setAttribute('height', 0.2);
        bg.setAttribute('position', '-0.3 -0.15 0');
        bg.setAttribute('color', panelColor);
        bg.setAttribute('radius', 0.02);
        this.el.appendChild(bg);

        const btn = document.createElement('a-entity');
        btn.setAttribute('ui-button', {
            label: this.currentMode === 'create' ? 'Create a watchlist' : 'Add Unit +',
            width: 0.5,
            height: 0.1,
            colorScheme: 'accent',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.02,
            preferredFontSize: 0.04
        });
        btn.setAttribute('position', '0 -0.05 0.02');
        btn.setAttribute('data-raycastable', '');
        
        btn.addEventListener('click', () => {
            if (this.currentMode === 'create') {
                if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showInputPopup) {
                    window.WatchlistApp.Popup.showInputPopup(
                        'New Watchlist',
                        '',
                        'Enter Name',
                        'Create',
                        async (name) => {
                            if (name) {
                                const Manager = window.WatchlistApp.Manager;
                                await Manager.createWatchlist(name, true); 
                                
                                const State = window.WatchlistApp.State;
                                if (State && State.allWatchlists) {
                                    const created = State.allWatchlists.find(w => w.name === name);
                                    if (created) {
                                        State.currentWatchlistId = created.id;
                                        State.currentWatchlistData = [];
                                    }
                                }

                                const visualizer = document.querySelector('#stock-visualizer');
                                if (visualizer && visualizer.components['stock-cube-visualizer']) {
                                    visualizer.components['stock-cube-visualizer'].fetchStockData();
                                }
                                
                                this.show('add');
                            }
                        }
                    );
                }
            } else {
                if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showAddUnitPopup) {
                    window.WatchlistApp.Popup.showAddUnitPopup({
                        onAdd: async (data) => {
                             const State = window.WatchlistApp.State;
                             const api = window.WatchlistAPIManager && window.WatchlistAPIManager.instance;
                             
                             if (!State || !api || !State.currentWatchlistId) return false;

                             try {
                                 await api.addTickersToWatchlist(State.currentWatchlistId, [{ ticker: data.ticker, quantity: data.quantity, price: data.price }]);
                                 const Manager = window.WatchlistApp.Manager;
                                 if (Manager) {
                                     await Manager.updateWatchlistState();
                                     await Manager.loadWatchlistData(State.currentUserId, State.currentWatchlistId, [], null, true);
                                 }
                             } catch (e) {
                                 console.error("[main-empty-state] Failed to add unit", e);
                                 return false; 
                             }

                             const visualizer = document.querySelector('#stock-visualizer');
                             if (visualizer && visualizer.components['stock-cube-visualizer']) {
                                 visualizer.components['stock-cube-visualizer'].fetchStockData();
                             }
                             return true;
                        }
                    });
                }
            }
        });
        
        this.el.appendChild(btn);
    }
});
